const options: any = {
  chart: {
    id: "vuechart-example-2"
  },
  labels: ['', 'Pending'],
  colors: ['#F0F6FF', '#0F3058'],
  legend: {
    show: false ,
    position: 'bottom',
  },
  plotOptions: {
    pie: {
      donut: {
        size: '60%',
      }
    }
  },
  dataLabels: {
    enabled: false
  },
  fill: {
    opacity: 1
  }
};

const series: any = [70, 30];

const type = 'donut';

const thinBar = { type, options, series };

export default thinBar; 
